/**
 * Shared order/refund constants used by both the wallet-portal drawer
 * (view_order) and the developer-portal orders page.
 */

export const REFUND_REASONS = [
    'Requested by customer',
    'Product out of stock',
    'Duplicate charge',
    'Order canceled',
    'Item damaged or defective',
    'Other'
] as const;

export type TRefundReason = (typeof REFUND_REASONS)[number];
